











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.ProductionSite.BinDestroyCommand')
    
    export class BinDestroyCommand {
        constructor( binId: number ) {
            
                this.binId = binId;
            
        }

        
            public binId: number;
        
    }

    export interface IBinDestroyCommand {
        
            binId: number;
        
    }

    export async function binDestroy( command: BinDestroyCommand ): Promise<CommandResult<void>>
    export async function binDestroy( { binId }: IBinDestroyCommand ): Promise<CommandResult<void>>
    export async function binDestroy( model: any ): Promise<CommandResult<void>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<void>;

        if(model instanceof BinDestroyCommand) {
            result = await endpoint.send<CommandResult<void>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<void>>( new BinDestroyCommand( model['binId'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace BinDestroyCommand.ExtraneousTypes {
        

        
    }

